import React, { useEffect } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web';
import keycloak from 'services/Keycloak';
import useAuth from 'redux/auth';
import { actions } from 'redux/auth/slice';
import { authProfile } from 'redux/auth/selectors';
import AppRoutes from 'routes/app';
import { updateToken } from 'util/Api';
import { initFaro } from 'util/faro';

const keycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  responseMode: 'query',
};

const AuthenticatedApp = () => {
  useAuth();
  const dispatch = useDispatch();
  const { keycloak: client, initialized } = useKeycloak();
  const profile = useSelector(authProfile);

  useEffect(() => {
    if (client.authenticated) {
      dispatch(actions.loginWithToken(client.token));
    }
  }, [client, client.authenticated, dispatch]);

  if (!initialized || !client.authenticated || !profile) {
    return null;
  }

  return (
    <BrowserRouter>
      <Route path="/" component={AppRoutes} />
    </BrowserRouter>
  );
};

const App = () => {
  useEffect(() => {
    initFaro();
  }, []);

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakInitOptions}
      onTokens={({ token }) => token && updateToken(token)}
    >
      <AuthenticatedApp />
    </ReactKeycloakProvider>
  );
};

export default App;
